// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyA0hvcrTJ24kGWa-aveEWmKH0sVdAfHg0E',
  authDomain: 'kei-finance-staging.firebaseapp.com',
  projectId: 'kei-finance-staging',
  storageBucket: 'kei-finance-staging.appspot.com',
  messagingSenderId: '19243824647',
  appId: '1:19243824647:web:06e7546e2e4ff1d5b95ca2',
  measurementId: 'G-226MBNJ24V',
};
